<template>
  <div>
    <div class="container">
      <e-search
        :data="filterInfoR.data"
        :field-list="filterInfoR.filterList"
        :list-type-info="listTypeInfoR"
        @handleFilter="handleQuery"
        @handleReset="handleReset"
      ></e-search>
    </div>

    <div class="container">
      <eTableList
        :table-data="tableData"
        :table-label="tableLabelR"
        :row-key="rowKey"
        style="margin-top: 10px"
      >
        <template #indexSlot="slot">
          <div class="flex-center-center">{{ slot.scope.$index + 1 }}</div>
        </template>

        <template #roleListRoleName="slot">
          <div
            v-if="slot.scope.row.roleList.length > 1"
            style="color: #2587ff; cursor: pointer"
            @click="viewRole(slot.scope.row.roleList)"
          >
            共计{{ slot.scope.row.roleList.length }}个角色
          </div>
          <div v-else>{{ slot.scope.row.roleList[0].roleName }}</div>
        </template>
        <template #reasonSlot="slot">
          {{ slot.scope.row.reason }}
        </template>
        <template #statuseSlot="slot">
          <!-- <el-tooltip
            class="icon"
            effect="dark"
            placement="top"
          >
            <div slot="content">{{slot.scope.row.opinion}}</div>
            <div class="icon">
              <div v-if="slot.scope.row.status === 3">审批拒绝</div>
            </div>
          </el-tooltip> -->
          <span v-if="slot.scope.row.status === 3"
            >审批拒绝
            <el-tooltip effect="dark" placement="top">
              <div slot="content">
                {{
                  slot.scope.row.opinion
                    ? slot.scope.row.opinion
                    : '暂无详细信息'
                }}
              </div>
              <span
                v-if="
                  slot.scope.row.opinion !== '' &&
                  slot.scope.row.opinion !== undefined
                "
                class="return-icon"
              >
                i
              </span>
            </el-tooltip>
          </span>
          <div v-if="slot.scope.row.status === 2">审批通过</div>
          <div v-if="slot.scope.row.status === 1">待审批</div>
        </template>
      </eTableList>
      <div class="pagination">
        <el-pagination
          :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="productTagPage.pageStart"
          :page-size="productTagPage.pageSize"
          :total="productTagPage.pageTotal"
          prev-text="上一页"
          next-text="下一页"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
    <ViewDialog
      :table-list="tableList"
      :visible="viewRoleDialogShow"
      @close="closeCheckRole"
    ></ViewDialog>
  </div>
</template>

<script>
import eTableList from '@/modules/projectA/components/common/e-table-list';
import ViewDialog from './components/viewRoleDialog.vue';
import Api from '../../api/authority';
import { roleApply } from './roleApply';
import eSearch from '../../components/common/e-search';

export default {
  name: 'RoleApplyRecord',
  components: {
    ViewDialog,
    eTableList,
    eSearch,
  },
  props: {},
  data() {
    return {
      roleApply,
      query: {
        roleName: null,
        remark: null,
        status: null,
      },
      filterInfoR: roleApply.filterInfoR,
      listTypeInfoR: roleApply.listTypeInfoR,
      tableData: [],
      tableLabelR: roleApply.tableLabelR,
      productTagPage: {
        pageStart: 1,
        pageSize: 10,
        pageTotal: 0,
      },
      roleData: {},
      rowKey: 'roleId',
      selectionData: [],
      tableList: [],
      viewRoleDialogShow: false,
    };
  },
  computed: {},
  created() {
    this.getList();
  },
  methods: {
    viewRole(roleList) {
      this.queryByRoleIdList(roleList);
    },
    queryByRoleIdList(roleList) {
      const params = {
        roleIdList: roleList.map((item) => item.roleId),
      };
      Api.queryByRoleIdList(params).then((res) => {
        if (res.code === '200') {
          this.tableList = res.data;
          this.viewRoleDialogShow = true;
        }
      });
    },
    closeCheckRole() {
      this.viewRoleDialogShow = false;
    },
    handleSelectionChange(val) {
      this.selectionData = val;
    },
    // 搜索
    handleQuery(val) {
      this.query = val;
      this.productTagPage.pageStart = 1;
      this.productTagPage.pageSize = 10;
      this.productTagPage.pageTotal = 0;
      this.getList();
    },
    // 重置
    handleReset() {
      this.query = {
        contactType: null,
        contacts: null,
        email: null,
        mobile: null,
      };
      this.productTagPage.pageStart = 1;
      this.productTagPage.pageSize = 10;
      this.productTagPage.pageTotal = 0;
      this.getList();
    },
    // 获得列表
    getList() {
      const params = this.query;
      // params.companyId = JSON.parse(localStorage.getItem('USERINFO')).companyId;
      params.pageSize = this.productTagPage.pageSize;
      params.pageStart = this.productTagPage.pageStart;

      Api.myApplyPage(params).then((res) => {
        this.tableData = res.data?.list;
        this.productTagPage.pageTotal = res.data.total;
      });
    },
    // 更改页码
    handleCurrentChange(val) {
      this.productTagPage.pageStart = val;
      this.getList();
    },

    // 更改条数
    handleSizeChange(val) {
      this.productTagPage.pageStart = 1;
      this.productTagPage.pageSize = val;
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  .return-icon {
    width: 16px;
    height: 16px;
    display: inline-block;
    border: 1.6px solid rgba(197, 197, 197, 1);
    line-height: 15px;
    text-align: center;
    border-radius: 100%;
    color: rgba(197, 197, 197, 1);
    margin-left: 5px;
    &:hover {
      background: rgba(197, 197, 197, 1);
      color: #fff;
    }
  }
  .text-box {
    padding: 11px 10px;
    background: #f4f7ff;
    font-size: 14px;
    font-style: normal;
    font-weight: 350;
    line-height: 24px;
    color: #666;
    margin-top: 10px;
    text-align: center;
  }
  .button-box {
    padding-bottom: 10px;
    margin-top: 10px;
  }
}
</style>
